// removed by extract-text-webpack-plugin
module.exports = {"labelButton":"styles__labelButton___AUNg1","rotate":"styles__rotate___2nEOS","fadein":"styles__fadein___Cr0P_","slideFromRight":"styles__slideFromRight___1NWSI","waves":"styles__waves___30ciL"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/components/LabelButtons/styles.scss
// module id = ./resources/assets/js/components/LabelButtons/styles.scss
// module chunks = 0